import React from 'react'

import useImmortalsEnabled from 'models/immortals/useImmortalsEnabled'

import { loadable } from 'containers/Loadable/Loadable'


const ImmortalsBanner = loadable(() => import('layers/immortals/pages/components/ImmortalsBanner/ImmortalsBanner'), { ssr: false })


type BannerProps = {
  className?: string
}

const Banner: React.FC<BannerProps> = (props) => {
  const { className } = props

  const { isImmortalsEnabled } = useImmortalsEnabled()

  if (!isImmortalsEnabled) {
    return null
  }

  return (
    <ImmortalsBanner className={className} />
  )
}


export default Banner
